/**
 * Scratch interaction adapted from https://codepen.io/andreruffert/pen/MWMbMj
 * (HTML5 Canvas scratch card by André Ruffert)
 */

const SCRATCH_BRUSH_SRC =
  "data:image/png;base64,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";

const BRUSH_OFFSET = 25;

function distanceBetween(point1, point2) {
  return Math.sqrt((point2.x - point1.x) ** 2 + (point2.y - point1.y) ** 2);
}

function angleBetween(point1, point2) {
  return Math.atan2(point2.x - point1.x, point2.y - point1.y);
}

function getMouse(event, canvas) {
  const rect = canvas.getBoundingClientRect();
  const clientX = event.touches?.[0]?.clientX ?? event.clientX;
  const clientY = event.touches?.[0]?.clientY ?? event.clientY;

  return {
    x: clientX - rect.left,
    y: clientY - rect.top
  };
}

class NewsletterScratchCard extends HTMLElement {
  #isDrawing = false;
  #isComplete = false;
  #initialized = false;
  #lastPoint = null;
  #ctx = null;
  #canvasWidth = 0;
  #canvasHeight = 0;
  #dpr = 1;
  #brush = null;
  #overlayImg = null;
  #resizeObserver = null;

  connectedCallback() {
    this.canvas = this.querySelector("canvas");
    if (!this.canvas) {
      return;
    }

    this.#ctx = this.canvas.getContext("2d", { willReadFrequently: true });
    this.threshold = parseFloat(this.getAttribute("threshold") || "45");
    this.scratchLabel = this.getAttribute("scratch-label") || "Scratch here";

    const tryDraw = () => {
      if (this.#canvasWidth && !this.#initialized && !this.#isComplete && this.#assetsReady()) {
        this.#drawOverlay();
        this.#initialized = true;
        this.classList.add("is-ready");
      }
    };

    this.#brush = new Image();
    this.#brush.src = SCRATCH_BRUSH_SRC;
    this.#brush.onload = tryDraw;

    const overlaySrc = this.getAttribute("overlay-image-src");
    if (overlaySrc) {
      this.#overlayImg = new Image();
      this.#overlayImg.crossOrigin = "anonymous";
      this.#overlayImg.src = overlaySrc;
      this.#overlayImg.onload = tryDraw;
    }

    this.#bindEvents();
    this.#bindVisibility();
  }

  #assetsReady() {
    const brushOk = this.#brush.complete && this.#brush.naturalWidth > 0;
    const overlayOk = !this.#overlayImg || (this.#overlayImg.complete && this.#overlayImg.naturalWidth > 0);
    return brushOk && overlayOk;
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
  }

  #bindVisibility() {
    const popup = this.closest("newsletter-popup");

    const tryInit = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.#initCanvas());
      });
    };

    popup?.addEventListener("dialog:after-show", tryInit);
    this.addEventListener("scratch-resize", tryInit);

    if (popup) {
      const openObserver = new MutationObserver(() => {
        if (popup.hasAttribute("open")) {
          tryInit();
        }
      });
      openObserver.observe(popup, { attributes: true, attributeFilter: ["open"] });
    }

    if (popup?.hasAttribute("open")) {
      tryInit();
    }
  }

  #initCanvas() {
    if (this.#isComplete) {
      return;
    }

    const rect = this.getBoundingClientRect();
    const width = rect.width;
    const height = rect.height;

    if (width < 2 || height < 2) {
      return;
    }

    this.#dpr = window.devicePixelRatio || 1;
    this.#canvasWidth = Math.floor(width * this.#dpr);
    this.#canvasHeight = Math.floor(height * this.#dpr);

    this.canvas.width = this.#canvasWidth;
    this.canvas.height = this.#canvasHeight;
    this.canvas.style.width = `${width}px`;
    this.canvas.style.height = `${height}px`;

    this.#ctx.setTransform(1, 0, 0, 1, 0, 0);
    this.#ctx.scale(this.#dpr, this.#dpr);

    if (this.#assetsReady()) {
      this.#drawOverlay();
      this.#initialized = true;
      this.classList.add("is-ready");
    }
  }

  #drawOverlay() {
    const width = this.#canvasWidth / this.#dpr;
    const height = this.#canvasHeight / this.#dpr;

    this.#ctx.globalCompositeOperation = "source-over";

    if (this.#overlayImg && this.#overlayImg.complete && this.#overlayImg.naturalWidth > 0) {
      // Draw the custom overlay image, cover-fit into the square
      const iw = this.#overlayImg.naturalWidth;
      const ih = this.#overlayImg.naturalHeight;
      const scale = Math.max(width / iw, height / ih);
      const sw = iw * scale;
      const sh = ih * scale;
      const sx = (width - sw) / 2;
      const sy = (height - sh) / 2;
      this.#ctx.drawImage(this.#overlayImg, sx, sy, sw, sh);
    } else {
      this.#ctx.fillStyle = "#000000";
      this.#ctx.fillRect(0, 0, width, height);
    }

    // Only draw the label when there is no custom overlay image
    if (!this.#overlayImg) {
      const fontSize = Math.max(11, Math.min(18, Math.round(Math.min(width, height) * 0.06)));
      this.#ctx.fillStyle = "#ffffff";
      this.#ctx.font = `600 ${fontSize}px var(--text-font-family, sans-serif)`;
      this.#ctx.textAlign = "center";
      this.#ctx.textBaseline = "middle";
      this.#ctx.fillText(this.scratchLabel.toUpperCase(), width / 2, height / 2);
    }
  }

  #getFilledInPixels(sampleStride = 32) {
    const pixels = this.#ctx.getImageData(0, 0, this.#canvasWidth, this.#canvasHeight);
    const pdata = pixels.data;
    let transparent = 0;
    let sampled = 0;

    // Must check alpha, not red — unscratched black overlay is rgb(0,0,0) too.
    for (let i = 3; i < pdata.length; i += sampleStride) {
      sampled++;
      if (pdata[i] === 0) {
        transparent++;
      }
    }

    return sampled > 0 ? Math.round((transparent / sampled) * 100) : 0;
  }

  #handlePercentage(filledInPixels) {
    if (filledInPixels >= this.threshold) {
      this.#complete();
    }
  }

  #scratchAt(point) {
    this.#ctx.globalCompositeOperation = "destination-out";

    if (this.#brush.complete && this.#brush.naturalWidth) {
      this.#ctx.drawImage(this.#brush, point.x - BRUSH_OFFSET, point.y - BRUSH_OFFSET);
    } else {
      this.#ctx.beginPath();
      this.#ctx.arc(point.x, point.y, BRUSH_OFFSET, 0, Math.PI * 2);
      this.#ctx.fill();
    }
  }

  #scratchBetween(from, to) {
    const dist = distanceBetween(from, to);
    const angle = angleBetween(from, to);

    for (let i = 0; i < dist; i++) {
      this.#scratchAt({
        x: from.x + Math.sin(angle) * i,
        y: from.y + Math.cos(angle) * i
      });
    }
  }

  #bindEvents() {
    const handleMouseDown = (event) => {
      if (this.#isComplete || !this.#initialized) {
        return;
      }

      this.#isDrawing = true;
      this.#lastPoint = getMouse(event, this.canvas);
      this.#scratchAt(this.#lastPoint);
      event.preventDefault();
    };

    const handleMouseMove = (event) => {
      if (!this.#isDrawing || this.#isComplete || !this.#initialized) {
        return;
      }

      event.preventDefault();

      const currentPoint = getMouse(event, this.canvas);
      this.#scratchBetween(this.#lastPoint, currentPoint);
      this.#lastPoint = currentPoint;
      this.#handlePercentage(this.#getFilledInPixels(32));
    };

    const handleMouseUp = () => {
      if (this.#isDrawing && !this.#isComplete) {
        this.#handlePercentage(this.#getFilledInPixels(32));
      }
      this.#isDrawing = false;
    };

    this.canvas.addEventListener("mousedown", handleMouseDown, false);
    this.canvas.addEventListener("mousemove", handleMouseMove, false);
    this.canvas.addEventListener("mouseup", handleMouseUp, false);
    this.canvas.addEventListener("mouseleave", handleMouseUp, false);

    this.canvas.addEventListener("touchstart", handleMouseDown, { passive: false });
    this.canvas.addEventListener("touchmove", handleMouseMove, { passive: false });
    this.canvas.addEventListener("touchend", handleMouseUp, false);
    this.canvas.addEventListener("touchcancel", handleMouseUp, false);

    this.#resizeObserver = new ResizeObserver(() => {
      if (!this.#isComplete && this.#initialized) {
        this.#initCanvas();
      }
    });
    this.#resizeObserver.observe(this);
  }

  #complete() {
    if (this.#isComplete) {
      return;
    }

    this.#isComplete = true;
    this.#isDrawing = false;
    this.classList.add("is-complete");
    this.canvas.style.pointerEvents = "none";
    this.dispatchEvent(new CustomEvent("scratch-complete", { bubbles: true }));
  }
}

/**
 * Klaviyo Create Client Subscription (onsite / client-side format).
 * @see https://developers.klaviyo.com/en/reference/create_client_subscription
 */
function subscribeToKlaviyoList(companyId, listId, { email, phone_number, properties, customSource = "Newsletter scratch popup" } = {}) {
  const profileAttributes = {};
  const subscriptions = {};

  if (email) {
    profileAttributes.email = email;
    subscriptions.email = {
      marketing: {
        consent: "SUBSCRIBED"
      }
    };
  }

  if (phone_number) {
    profileAttributes.phone_number = phone_number;
    subscriptions.sms = {
      marketing: {
        consent: "SUBSCRIBED"
      }
    };
  }

  if (properties && Object.keys(properties).length > 0) {
    profileAttributes.properties = properties;
  }

  if (Object.keys(subscriptions).length > 0) {
    profileAttributes.subscriptions = subscriptions;
  }

  return fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`, {
    method: "POST",
    headers: {
      "content-type": "application/vnd.api+json",
      revision: "2026-04-15"
    },
    body: JSON.stringify({
      data: {
        type: "subscription",
        attributes: {
          custom_source: customSource,
          profile: {
            data: {
              type: "profile",
              attributes: profileAttributes
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: listId
            }
          }
        }
      }
    })
  });
}

function initNewsletterScratchPopup(popup) {
  if (popup.dataset.scratchInit === "true") {
    return;
  }

  popup.dataset.scratchInit = "true";

  const steps = popup.querySelectorAll("[data-newsletter-step]");
  const scratchCard = popup.querySelector("newsletter-scratch-card");

  const goToStep = (stepName) => {
    steps.forEach((step) => {
      step.hidden = step.dataset.newsletterStep !== stepName;
    });
    popup.dataset.currentStep = stepName;
  };

  const initialStep = popup.dataset.initialStep || "scratch";
  goToStep(initialStep);

  const scratchStep = popup.querySelector('[data-newsletter-step="scratch"]');
  const claimButton = popup.querySelector(".newsletter-scratch__claim");

  scratchCard?.addEventListener("scratch-complete", () => {
    const prize = scratchStep?.querySelector(".newsletter-scratch__prize");
    const actions = scratchStep?.querySelector(".newsletter-scratch__actions");
    const reveal = scratchStep?.querySelector(".newsletter-scratch__reveal");

    scratchStep?.classList.add("is-revealed");
    prize?.removeAttribute("hidden");
    actions?.removeAttribute("hidden");
    reveal?.removeAttribute("hidden");

    if (claimButton) {
      claimButton.focus();
    } else {
      goToStep("form");
      popup.querySelector(".newsletter-scratch__email-input")?.focus();
    }
  });

  claimButton?.addEventListener("click", () => {
    goToStep("form");
    popup.querySelector(".newsletter-scratch__email-input")?.focus();
  });

  // ─── Email step — Klaviyo, instant advance to phone ──────
  const emailSubmit = popup.querySelector(".newsletter-scratch__email-submit");
  const emailInput  = popup.querySelector(".newsletter-scratch__email-input");

  emailSubmit?.addEventListener("click", () => {
    if (!emailInput?.checkValidity()) {
      emailInput?.reportValidity();
      return;
    }

    const email = emailInput.value.trim();
    popup.dataset.subscriberEmail = email;
    goToStep("phone");

    const companyId = popup.dataset.klaviyoCompanyId;
    const listId    = popup.dataset.klaviyoEmailListId;

    if (email && companyId && listId) {
      subscribeToKlaviyoList(companyId, listId, { email }).catch(() => {});
    }

    popup.querySelector(".newsletter-scratch__phone-input")?.focus();
  });

  emailInput?.addEventListener("keydown", (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      emailSubmit?.click();
    }
  });

  // ─── Phone step ───────────────────────────────────────────
  const phoneSubmit = popup.querySelector(".newsletter-scratch__phone-submit");
  const completePhoneStep = () => {
    localStorage.setItem("theme:popup-filled", "true");
    goToStep("success");
  };

  phoneSubmit?.addEventListener("click", () => {
    const phoneInput    = popup.querySelector(".newsletter-scratch__phone-input");
    const countryPrefix = popup.querySelector(".newsletter-scratch__phone-prefix")?.textContent?.trim() || "";
    const rawPhone      = phoneInput?.value?.trim() || "";
    const fullPhone     = rawPhone ? countryPrefix + rawPhone.replace(/^0/, "") : "";

    const companyId = popup.dataset.klaviyoCompanyId;
    const listId    = popup.dataset.klaviyoSmsListId;

    const subscriberEmail = popup.dataset.subscriberEmail;
    const smsPayload = { phone_number: fullPhone };

    if (subscriberEmail) {
      smsPayload.properties = { email: subscriberEmail };
    }

    if (fullPhone && companyId && listId) {
      phoneSubmit.setAttribute("aria-busy", "true");

      subscribeToKlaviyoList(companyId, listId, smsPayload)
        .catch(() => {})
        .finally(() => {
          phoneSubmit.removeAttribute("aria-busy");
          completePhoneStep();
        });
    } else {
      completePhoneStep();
    }
  });

  // ──────────────────────────────────────────────────────────

  // ─── Discount code copy ───────────────────────────────────
  popup.querySelectorAll(".newsletter-scratch__code-box").forEach((box) => {
    box.addEventListener("click", () => {
      const code   = box.dataset.discountCode;
      const copied = box.querySelector(".newsletter-scratch__code-copied");
      const icon   = box.querySelector(".newsletter-scratch__code-icon");
      if (!code) return;

      navigator.clipboard.writeText(code).then(() => {
        icon?.setAttribute("hidden", "");
        copied?.removeAttribute("hidden");
        setTimeout(() => {
          icon?.removeAttribute("hidden");
          copied?.setAttribute("hidden", "");
        }, 2000);
      }).catch(() => {
        // Fallback for non-secure contexts
        const ta = document.createElement("textarea");
        ta.value = code;
        ta.style.cssText = "position:absolute;opacity:0;";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        ta.remove();
        icon?.setAttribute("hidden", "");
        copied?.removeAttribute("hidden");
        setTimeout(() => {
          icon?.removeAttribute("hidden");
          copied?.setAttribute("hidden", "");
        }, 2000);
      });
    });
  });
  // ──────────────────────────────────────────────────────────

  popup.addEventListener("dialog:after-show", () => {
    scratchCard?.dispatchEvent(new CustomEvent("scratch-resize"));
  });

  if (popup.hasAttribute("open")) {
    scratchCard?.dispatchEvent(new CustomEvent("scratch-resize"));
  }
}

function initAllNewsletterScratchPopups() {
  document.querySelectorAll("newsletter-popup.modal--newsletter-scratch").forEach(initNewsletterScratchPopup);
}

if (!window.customElements.get("newsletter-scratch-card")) {
  window.customElements.define("newsletter-scratch-card", NewsletterScratchCard);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAllNewsletterScratchPopups);
} else {
  initAllNewsletterScratchPopups();
}

document.addEventListener("shopify:section:load", initAllNewsletterScratchPopups);
